import React from 'react';
import { SERVER_URL } from '../constants'
import toast from 'react-hot-toast';

const useWithdraw = ({ closeModal }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (!user) window.location.href = '/login';

  const route = '/withdraws';

  const [amount, setAmount] = React.useState(0);
  const [address, setAddress] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const handleAmountChange = (e, balance) => {

    if (Number(e.target.value) > balance) {
      setError('Insufficient funds');
    } else {
      setError(null);
      setAmount(e.target.value);
    }
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  const withdraw = async () => {
    setLoading(true);
    if (amount <= 0 || !address) return setLoading(false);
    const response = await fetch(`${SERVER_URL}${route}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token') || '',
      },
      body: JSON.stringify({
        amount,
        walletAddress: address,
        userId: user?._id,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      window.location.reload();
      closeModal();
    } else {
      console.error('Deposit failed');
      toast.error(data.message);
    }
    setLoading(false);
  };

  return {
    loading,
    withdraw,
    amount,
    address,
    handleAmountChange,
    handleAddressChange,
    error,
  };
};

export default useWithdraw;
